module.exports = __webpack_public_path__ + "img/skyline-generic@2x.819fe5d.png";